function FAQs () {
    return (
        <>
            <div className="row g-4">
                <div className="col-md-12">
                    <div className="accordion" id="faqAccordion">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
                                    Is this website free to use ?
                                </button>
                            </h2>

                            <div id="faq1" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                <div className="accordion-body">
                                    Yes, this website is completely free to use. We do not charge from companies to see the CVs they have received. We also do not charge the job seekers to get hired fast.
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="true" aria-controls="faq2">
                                    Can I buy this website ?
                                </button>
                            </h2>

                            <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                <div className="accordion-body">
                                    Yes, you can buy the source code of this website. You will get frontend (React) and backend (Laravel) along with admin panel. We will also help you in deployment to your server or hosting.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FAQs;